module.exports = __webpack_public_path__ + "static/media/YouTube.5a422769.svg";